import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import TestimonialCarousel from "../components/TestimonialCarousel";

const TESTIMONIALS = [
  {
    quote:
      "Byteflow simplified our business operations. The payroll system alone saved us hours every week.",
    name: "Ramesh G.",
    role: "HR Manager, Textile Co.",
  },
  {
    quote:
      "Very intuitive and scalable. We integrated it with our existing tools quickly.",
    name: "Neha M.",
    role: "COO, North Star Retail",
  },
  {
    quote:
      "Great support team and excellent onboarding. Byteflow is the ERP we needed.",
    name: "Akshay T.",
    role: "Founder, Delta Electronics",
  },
  {
    quote:
      "We rolled out across three plants in under a month. The inventory module is exactly what we needed.",
    name: "Priya S.",
    role: "Operations Head, Unitech Gears",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const Testimonials = () => (
  <>
    <section className="page-hero">
      <motion.div
        className="page-hero__inner"
        initial="hidden"
        animate="visible"
        variants={fadeUp}
      >
        <p className="eyebrow">Testimonials</p>
        <h1>What our customers say</h1>
        <p className="page-hero__lead">
          Real feedback from teams running their day-to-day on Byteflow.
        </p>
      </motion.div>
    </section>

    <section className="section">
      <TestimonialCarousel items={TESTIMONIALS} />
    </section>

    <section className="section">
      <div className="testimonial-wall">
        {TESTIMONIALS.map((t) => (
          <blockquote className="testimonial-card testimonial-card--static" key={t.name}>
            <p className="testimonial-quote">“{t.quote}”</p>
            <footer className="testimonial-attribution">
              <strong>{t.name}</strong>
              <span>{t.role}</span>
            </footer>
          </blockquote>
        ))}
      </div>
    </section>

    <section className="cta-strip">
      <div className="cta-strip__inner">
        <div>
          <h2>Want to be our next success story?</h2>
          <p>Book a free walkthrough — we’ll tailor it to your business.</p>
        </div>
        <Link to="/contact" className="btn-primary btn-primary--inverse">
          Request a Demo
        </Link>
      </div>
    </section>
  </>
);

export default Testimonials;
